module.exports = __webpack_public_path__ + "static/media/banner8.06885ca6.png";